import React from "react";
import { ManageDistributionLayout } from "../../../components";
import { WithdrawalRequestPendingApprovalContainer } from "../../../containers";
import { ManageDistributionProvider } from "../../../contexts";
import WithdrawalSummaryContainer from "./../../../containers/Distribution/WithdrawalSummaryContainer/WithdrawalSummaryContainer";

const WithdrawalRequestsPendingApproval = (props) => {
  return (
    <ManageDistributionProvider>
      <WithdrawalRequestPendingApprovalContainer {...props} />
    </ManageDistributionProvider>
  );
};

export default WithdrawalRequestsPendingApproval;
